import { checkLang, formatTimeMin } from '../helpers';
import {
  localStorageLang,
  EXTRA_FEED_SEPARATOR,
  FEED_URLSRC_CMS_V2,
} from '../constants';
import { globalFetch } from './globalActions';
import {
  EXTRAFEED_HAS_ERRORED,
  EXTRAFEED_IS_LOADING,
  EXTRAFEED_FETCH_DATA_SUCCESS,
  EXTRAFEED_HOME_HAS_ERRORED,
  EXTRAFEED_HOME_IS_LOADING,
  EXTRAFEED_HOME_FETCH_DATA_SUCCESS,
} from './types';
import { uiStrings as strings } from './ui_strings';

///////////
// Extra Feeds //
///////////

export function fetchExtraFeedHome() {
  return globalFetch({
    urlPath: 'online-exclusive-cards',
    urlSrc: FEED_URLSRC_CMS_V2,
    reducerIsLoading: EXTRAFEED_HOME_IS_LOADING,
    reducerError: EXTRAFEED_HOME_HAS_ERRORED,
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch(fetchExtraFeedHomeSuccess(itemObj));
    },
  });
}

export function fetchExtraFeedHomeSuccess(items) {
  const lang =
    localStorage.getItem(localStorageLang) === null
      ? 0
      : parseInt(localStorage.getItem(localStorageLang), 10);

  let streams = [];
  items.results &&
    items.results.length > 0 &&
    items.results.forEach((value, key) => {
      streams.push({
        url: value.pathName,
        title: value.title,
        description: value.description,
        streamName: value.streamName,
        start_time_text: value.timeFrom,
        end_time_text: value.timeTo,
        live_date_time: value.startLiveDateTime,
        end_date_time: value.endDateTime,
        stream_type: value.header,
        image: value.image.path,
        wowzApplication: value.wowzaApplication,
        streamingUrl: value.hlsVideoUrl,
        mediaLive: value.mediaLive,
        time_text: `${value.timeFrom} ${EXTRA_FEED_SEPARATOR} ${value.timeTo}`,
        hide_link_text: formatTimeMin(
          lang,
          value.startLiveDateTime,
          strings,
          value.timeFrom
        ),
        hide_link:
          new Date() < new Date(value.startLiveDateTime) ? true : false,
      });
    });

  return { type: EXTRAFEED_HOME_FETCH_DATA_SUCCESS, payload: streams };
}

export function fetchExtraFeed(slug) {
  return globalFetch({
    urlPath: `online-exclusive-cards`,
    extraParams: `&lang=cy`,
    extraParamsLang: false,
    urlSrc: FEED_URLSRC_CMS_V2,
    reducerIsLoading: EXTRAFEED_IS_LOADING,
    reducerError: EXTRAFEED_HAS_ERRORED,
    dispatchSuccess: (ItemObj, dispatch) => {
      dispatch(fetchExtraFeedEn(ItemObj.results, slug));
    },
  });
}

export function fetchExtraFeedEn(items, slug) {
  return globalFetch({
    urlPath: `online-exclusive-cards`,
    extraParams: `&lang=en`,
    extraParamsLang: false,
    urlSrc: FEED_URLSRC_CMS_V2,
    reducerIsLoading: EXTRAFEED_IS_LOADING,
    reducerError: EXTRAFEED_HAS_ERRORED,
    dispatchSuccess: (ItemObj, dispatch) => {
      dispatch(fetchExtraFeedSuccess([items, ItemObj.results], slug));
    },
  });
}

function otherLangData(id, items) {
  return items.find((item) => item.id === id);
}

export function fetchExtraFeedSuccess(items, slug) {
  let chosenFeed = {},
    otherLang = '';
  if (items && items.length > 0) {
    for (var i = 0; i < items.length; i++) {
      if (items[i] && items[i].length > 0) {
        for (var j = 0; j < items[i].length; j++) {
          otherLang = '';
          if (slug === items[i][j].pathName) {
            otherLang = otherLangData(items[i][j].id, items[i === 0 ? 1 : 0]);
            chosenFeed = {
              description: items[i][j].description,
              url: items[i][j].pathName,
              title: items[i][j].title,
              subTitle: items[i][j].header,
              other_url: otherLang.pathName,
              url_lang: i,
              image: items[i][j].image.path,
              stream_type: items[i][j].header,
              wowzApplication: items[i][j].wowzaApplication,
              streamingUrl: items[i][j].hlsVideoUrl + `?lang=${checkLang(i)}`,
              otherCommsUrl: items[i][j].otherCommentaryBtnText,
              streamName: items[i][j].streamName + `?lang=${checkLang(i)}`,
            };
            break;
          }
        }
      }
    }
  }

  return {
    type: EXTRAFEED_FETCH_DATA_SUCCESS,
    payload: chosenFeed,
  };
}
